// @generated by protoc-gen-es v2.13.0 with parameter "target=ts,import_extension=js"
// @generated from file mlo/foundation/v1/foundation.proto (package mlo.foundation.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file mlo/foundation/v1/foundation.proto.
 */
export const file_mlo_foundation_v1_foundation: GenFile = /*@__PURE__*/
  fileDesc("CiJtbG8vZm91bmRhdGlvbi92MS9mb3VuZGF0aW9uLnByb3RvEhFtbG8uZm91bmRhdGlvbi52MSIiChFQcm90b2NvbFZlcnNpb25WMRINCgVtYWpvchgBIAEoDSLRAQoOUGFpcmluZ09mZmVyVjESFgoOcHJvdG9jb2xfbWFqb3IYASABKA0SEgoKc2Vzc2lvbl9pZBgCIAEoDBIYChBjb25uZWN0b3Jfb3JpZ2luGAMgASgJEhgKEHNpZ25hbGluZ19vcmlnaW4YBCABKAkSFQoNZXhwaXJlc19hdF9tcxgFIAEoBBINCgVub25jZRgGIAEoDBIaChJicm93c2VyX3B1YmxpY19rZXkYByABKAwSHQoVY2xhaW1lZF9icm93c2VyX2xhYmVsGAggASgJIm0KElBob25lS2V5UmVzcG9uc2VWMRISCgpzZXNzaW9uX2lkGAEgASgMEhIKCm9mZmVyX2hhc2gYAiABKAwSGAoQcGhvbmVfcHVibGljX2tleRgDIAEoDBIVCg1leHBpcmVzX2F0X21zGAQgASgEIk0KEVBhaXJpbmdBcHByb3ZlZFYxEhIKCnNlc3Npb25faWQYASABKAwSJAoccGhvbmVfcHVibGljX2tleV9maW5nZXJwcmludBgCIAEoDCKMAQoQU2Vzc2lvbkNvbmZpcm1WMRImCh5icm93c2VyX3B1YmxpY19rZXlfZmluZ2VycHJpbnQYASABKAwSJAoccGhvbmVfcHVibGljX2tleV9maW5nZXJwcmludBgCIAEoDBISCgpvZmZlcl9oYXNoGAMgASgMEhYKDnByb3RvY29sX21ham9yGAQgASgNIpUCCg5TZXNzaW9uUmVhZHlWMRISCgpzZXNzaW9uX2lkGAEgASgMEhgKEGFjdG9yX3Byb2ZpbGVfaWQYAiABKAwSGgoSYWN0b3JfZGlzcGxheV9uYW1lGAMgASgJEjIKCmFjdG9yX3JvbGUYBCABKA4yHi5tbG8uZm91bmRhdGlvbi52MS5BY3RvclJvbGVWMRIaChJpZGxlX2V4cGlyZXNfYXRfbXMYBSABKAQSHgoWYWJzb2x1dGVfZXhwaXJlc19hdF9tcxgGIAEoBBIVCg1zY29wZV92ZXJzaW9uGAcgASgEEjIKCnN5bmNfc3RhcnQYCCABKA4yHi5tbG8uZm91bmRhdGlvbi52MS5TeW5jU3RhcnRWMSJrCg1TdGFibGVFcnJvclYxEiwKBGNvZGUYASABKA4yHi5tbG8uZm91bmRhdGlvbi52MS5FcnJvckNvZGVWMRIUCgxzYWZlX21lc3NhZ2UYAiABKAkSFgoOY29ycmVsYXRpb25faWQYAyABKAki3AEKCkNvbmZsaWN0VjESEQoJZW50aXR5X2lkGAEgASgMEhgKEGN1cnJlbnRfcmV2aXNpb24YAiABKAQSHQoVcmVqZWN0ZWRfb3BlcmF0aW9uX2lkGAMgASgMEjUKBmNsaWVudBgKIAEoCzIjLm1sby5mb3VuZGF0aW9uLnYxLkNsaWVudFNuYXBzaG90VjFIABI5Cghkb2N1bWVudBgLIAEoCzIlLm1sby5mb3VuZGF0aW9uLnYxLkRvY3VtZW50U25hcHNob3RWMUgAQhAKDnJlcHJlc2VudGF0aW9uIqICChVJZGVtcG90ZW5jeU1hdGVyaWFsVjESFgoOcHJvdG9jb2xfbWFqb3IYASABKA0SFAoMb3BlcmF0aW9uX2lkGAIgASgMEhIKCnNlc3Npb25faWQYAyABKAwSGAoQYWN0b3JfcHJvZmlsZV9pZBgEIAEoDBI2Cgxjb21tYW5kX3R5cGUYBSABKA4yIC5tbG8uZm91bmRhdGlvbi52MS5Db21tYW5kVHlwZVYxEjQKC2VudGl0eV90eXBlGAYgASgOMh8ubWxvLmZvdW5kYXRpb24udjEuRW50aXR5VHlwZVYxEhEKCWVudGl0eV9pZBgHIAEoDBIVCg1iYXNlX3JldmlzaW9uGAggASgEEhUKDXR5cGVkX2NvbW1hbmQYCSABKAwiiAMKEENsaWVudFNuYXBzaG90VjESEQoJY2xpZW50X2lkGAEgASgMEhYKDm93bmVyX2FjdG9yX2lkGAIgASgMEgwKBG5hbWUYAyABKAkSDQoFZW1haWwYBCABKAkSDQoFcGhvbmUYBSABKAkSDwoHYWRkcmVzcxgGIAEoCRIMCgRjaXR5GAcgASgJEg0KBXN0YXRlGAggASgJEhMKC3Bvc3RhbF9jb2RlGAkgASgJEgwKBHRhZ3MYCiADKAkSDgoGc3RhdHVzGAsgASgJEhAKCHJldmlzaW9uGAwgASgEEhUKDXVwZGF0ZWRfYXRfbXMYDSABKAQSEAoIYXJjaGl2ZWQYDiABKAgSTAoNY3VzdG9tX2ZpZWxkcxgPIAMoCzI1Lm1sby5mb3VuZGF0aW9uLnYxLkNsaWVudFNuYXBzaG90VjEuQ3VzdG9tRmllbGRzRW50cnkaMwoRQ3VzdG9tRmllbGRzRW50cnkSCwoDa2V5GAEgASgJEg0KBXZhbHVlGAIgASgJOgI4ASLeAQoSRG9jdW1lbnRTbmFwc2hvdFYxEhMKC2RvY3VtZW50X2lkGAEgASgMEhEKCWNsaWVudF9pZBgCIAEoDBIUCgxkaXNwbGF5X25hbWUYAyABKAkSEAoIY2F0ZWdvcnkYBCABKAkSDgoGc3RhdHVzGAUgASgJEhAKCHJldmlzaW9uGAYgASgEEh4KFmFjdGl2ZV9maWxlX3ZlcnNpb25faWQYByABKAwSDQoFbm90ZXMYCCABKAkSFQoNdXBkYXRlZF9hdF9tcxgJIAEoBBIQCghhcmNoaXZlZBgKIAEoCCKmAgoOQ3JlYXRlQ2xpZW50VjESFgoOb3duZXJfYWN0b3JfaWQYASABKAwSDAoEbmFtZRgCIAEoCRINCgVlbWFpbBgDIAEoCRINCgVwaG9uZRgEIAEoCRIPCgdhZGRyZXNzGAUgASgJEgwKBGNpdHkYBiABKAkSDQoFc3RhdGUYByABKAkSEwoLcG9zdGFsX2NvZGUYCCABKAkSDAoEdGFncxgJIAMoCRJKCg1jdXN0b21fZmllbGRzGAogAygLMjMubWxvLmZvdW5kYXRpb24udjEuQ3JlYXRlQ2xpZW50VjEuQ3VzdG9tRmllbGRzRW50cnkaMwoRQ3VzdG9tRmllbGRzRW50cnkSCwoDa2V5GAEgASgJEg0KBXZhbHVlGAIgASgJOgI4ASKyAwoOVXBkYXRlQ2xpZW50VjESEwoLdXBkYXRlX21hc2sYASADKAkSEQoEbmFtZRgCIAEoCUgAiAEBEhIKBWVtYWlsGAMgASgJSAGIAQESEgoFcGhvbmUYBCABKAlIAogBARIUCgdhZGRyZXNzGAUgASgJSAOIAQESEQoEY2l0eRgGIAEoCUgEiAEBEhIKBXN0YXRlGAcgASgJSAWIAQESGAoLcG9zdGFsX2NvZGUYCCABKAlIBogBARIMCgR0YWdzGAkgAygJEhMKBnN0YXR1cxgKIAEoCUgHiAEBEkoKDWN1c3RvbV9maWVsZHMYCyADKAsyMy5tbG8uZm91bmRhdGlvbi52MS5VcGRhdGVDbGllbnRWMS5DdXN0b21GaWVsZHNFbnRyeRozChFDdXN0b21GaWVsZHNFbnRyeRILCgNrZXkYASABKAkSDQoFdmFsdWUYAiABKAk6AjgBQgcKBV9uYW1lQggKBl9lbWFpbEIICgZfcGhvbmVCCgoIX2FkZHJlc3NCBwoFX2NpdHlCCAoGX3N0YXRlQg4KDF9wb3N0YWxfY29kZUIJCgdfc3RhdHVzIhEKD0FyY2hpdmVDbGllbnRWMSKLAQoWQ29tbWl0RG9jdW1lbnRVcGxvYWRWMRITCgt0cmFuc2Zlcl9pZBgBIAEoDBITCgtkb2N1bWVudF9pZBgCIAEoDBIXCg9maWxlX3ZlcnNpb25faWQYAyABKAwSFAoMdG90YWxfY2h1bmtzGAQgASgNEhgKEHBsYWludGV4dF9zaGEyNTYYBSABKAwisAMKEENvbW1hbmRSZXF1ZXN0VjESFAoMb3BlcmF0aW9uX2lkGAEgASgMEhgKEGFjdG9yX3Byb2ZpbGVfaWQYAiABKAwSNAoLZW50aXR5X3R5cGUYAyABKA4yHy5tbG8uZm91bmRhdGlvbi52MS5FbnRpdHlUeXBlVjESEQoJZW50aXR5X2lkGAQgASgMEhUKDWJhc2VfcmV2aXNpb24YBSABKAQSOgoNY3JlYXRlX2NsaWVudBgKIAEoCzIhLm1sby5mb3VuZGF0aW9uLnYxLkNyZWF0ZUNsaWVudFYxSAASOgoNdXBkYXRlX2NsaWVudBgLIAEoCzIhLm1sby5mb3VuZGF0aW9uLnYxLlVwZGF0ZUNsaWVudFYxSAASPAoOYXJjaGl2ZV9jbGllbnQYDCABKAsyIi5tbG8uZm91bmRhdGlvbi52MS5BcmNoaXZlQ2xpZW50VjFIABJLChZjb21taXRfZG9jdW1lbnRfdXBsb2FkGA0gASgLMikubWxvLmZvdW5kYXRpb24udjEuQ29tbWl0RG9jdW1lbnRVcGxvYWRWMUgAQgkKB2NvbW1hbmQicgoUTGlzdENsaWVudHNSZXF1ZXN0VjESDQoFcXVlcnkYASABKAkSDgoGc3RhdHVzGAIgASgJEhgKEGluY2x1ZGVfYXJjaGl2ZWQYAyABKAgSEQoJcGFnZV9zaXplGAQgASgNEg4KBmN1cnNvchgFIAEoDCInChJHZXRDbGllbnRSZXF1ZXN0VjESEQoJY2xpZW50X2lkGAEgASgMIk4KFkxpc3REb2N1bWVudHNSZXF1ZXN0VjESEQoJY2xpZW50X2lkGAEgASgMEhEKCXBhZ2Vfc2l6ZRgCIAEoDRIOCgZjdXJzb3IYAyABKAwi/QEKF1ByZXBhcmVEb2N1bWVudFVwbG9hZFYxEhMKCWNsaWVudF9pZBgBIAEoDEgAEhUKC2RvY3VtZW50X2lkGAIgASgMSAASFAoMb3BlcmF0aW9uX2lkGAMgASgMEhUKDWJhc2VfcmV2aXNpb24YBCABKAQSFAoMZGlzcGxheV9uYW1lGAUgASgJEhAKCGNhdGVnb3J5GAYgASgJEg0KBW5vdGVzGAcgASgJEhoKEm9yaWdpbmFsX2ZpbGVfbmFtZRgIIAEoCRIVCg1kZWNsYXJlZF9taW1lGAkgASgJEhUKDWRlY2xhcmVkX3NpemUYCiABKARCCAoGdGFyZ2V0IsMCChdQcmVwYXJlVXBsb2FkTWF0ZXJpYWxWMRIWCg5wcm90b2NvbF9tYWpvchgBIAEoDRIUCgxvcGVyYXRpb25faWQYAiABKAwSEgoKc2Vzc2lvbl9pZBgDIAEoDBIYChBhY3Rvcl9wcm9maWxlX2lkGAQgASgMEhMKCWNsaWVudF9pZBgFIAEoDEgAEhUKC2RvY3VtZW50X2lkGAYgASgMSAASFQoNYmFzZV9yZXZpc2lvbhgHIAEoBBIUCgxkaXNwbGF5X25hbWUYCCABKAkSEAoIY2F0ZWdvcnkYCSABKAkSDQoFbm90ZXMYCiABKAkSGgoSb3JpZ2luYWxfZmlsZV9uYW1lGAsgASgJEhUKDWRlY2xhcmVkX21pbWUYDCABKAkSFQoNZGVjbGFyZWRfc2l6ZRgNIAEoBEIICgZ0YXJnZXQiMgoXQmVnaW5Eb2N1bWVudERvd25sb2FkVjESFwoPZmlsZV92ZXJzaW9uX2lkGAEgASgMIjYKEUdldENoYW5nZXNBZnRlclYxEg4KBmN1cnNvchgBIAEoDBIRCglwYWdlX3NpemUYAiABKA0iJAoNR2V0U25hcHNob3RWMRITCgtzbmFwc2hvdF9pZBgBIAEoDCL3AwoOUXVlcnlSZXF1ZXN0VjESPwoMbGlzdF9jbGllbnRzGAogASgLMicubWxvLmZvdW5kYXRpb24udjEuTGlzdENsaWVudHNSZXF1ZXN0VjFIABI7CgpnZXRfY2xpZW50GAsgASgLMiUubWxvLmZvdW5kYXRpb24udjEuR2V0Q2xpZW50UmVxdWVzdFYxSAASQwoObGlzdF9kb2N1bWVudHMYDCABKAsyKS5tbG8uZm91bmRhdGlvbi52MS5MaXN0RG9jdW1lbnRzUmVxdWVzdFYxSAASTQoXcHJlcGFyZV9kb2N1bWVudF91cGxvYWQYDSABKAsyKi5tbG8uZm91bmRhdGlvbi52MS5QcmVwYXJlRG9jdW1lbnRVcGxvYWRWMUgAEk0KF2JlZ2luX2RvY3VtZW50X2Rvd25sb2FkGA4gASgLMioubWxvLmZvdW5kYXRpb24udjEuQmVnaW5Eb2N1bWVudERvd25sb2FkVjFIABJBChFnZXRfY2hhbmdlc19hZnRlchgPIAEoCzIkLm1sby5mb3VuZGF0aW9uLnYxLkdldENoYW5nZXNBZnRlclYxSAASOAoMZ2V0X3NuYXBzaG90GBAgASgLMiAubWxvLmZvdW5kYXRpb24udjEuR2V0U25hcHNob3RWMUgAQgcKBXF1ZXJ5ImsKDENsaWVudFBhZ2VWMRI0CgdjbGllbnRzGAEgAygLMiMubWxvLmZvdW5kYXRpb24udjEuQ2xpZW50U25hcHNob3RWMRITCgtuZXh0X2N1cnNvchgCIAEoDBIQCgh0ZXJtaW5hbBgDIAEoCCJxCg5Eb2N1bWVudFBhZ2VWMRI4Cglkb2N1bWVudHMYASADKAsyJS5tbG8uZm91bmRhdGlvbi52MS5Eb2N1bWVudFNuYXBzaG90VjESEwoLbmV4dF9jdXJzb3IYAiABKAwSEAoIdGVybWluYWwYAyABKAgigAEKEFVwbG9hZFByZXBhcmVkVjESEwoLdHJhbnNmZXJfaWQYASABKAwSEwoLZG9jdW1lbnRfaWQYAiABKAwSFwoPZmlsZV92ZXJzaW9uX2lkGAMgASgMEhIKCmNodW5rX3NpemUYBCABKA0SFQoNZXhwaXJlc19hdF9tcxgFIAEoBCLkAQoSRG93bmxvYWRQcmVwYXJlZFYxEhMKC3RyYW5zZmVyX2lkGAEgASgMEhcKD2ZpbGVfdmVyc2lvbl9pZBgCIAEoDBIUCgx0b3RhbF9jaHVua3MYAyABKA0SEgoKY2h1bmtfc2l6ZRgEIAEoDRIWCg5wbGFpbnRleHRfc2l6ZRgFIAEoBBIYChBwbGFpbnRleHRfc2hhMjU2GAYgASgMEhUKDWV4cGlyZXNfYXRfbXMYByABKAQSGgoSb3JpZ2luYWxfZmlsZV9uYW1lGAggASgJEhEKCW1pbWVfdHlwZRgJIAEoCSKDAQoMQ2hhbmdlUGFnZVYxEjMKBmV2ZW50cxgBIAMoCzIjLm1sby5mb3VuZGF0aW9uLnYxLkNvbW1pdHRlZEV2ZW50VjESFwoPdGVybWluYWxfY3Vyc29yGAIgASgMEhAKCHRlcm1pbmFsGAMgASgIEhMKC25leHRfY3Vyc29yGAQgASgMIs4ECgpSZXNwb25zZVYxEhIKCnJlcXVlc3RfaWQYASABKAwSEwoLc3luY19jdXJzb3IYAyABKAwSNQoGY2xpZW50GAogASgLMiMubWxvLmZvdW5kYXRpb24udjEuQ2xpZW50U25hcHNob3RWMUgAEjYKC2NsaWVudF9wYWdlGAsgASgLMh8ubWxvLmZvdW5kYXRpb24udjEuQ2xpZW50UGFnZVYxSAASOgoNZG9jdW1lbnRfcGFnZRgMIAEoCzIhLm1sby5mb3VuZGF0aW9uLnYxLkRvY3VtZW50UGFnZVYxSAASPgoPdXBsb2FkX3ByZXBhcmVkGA0gASgLMiMubWxvLmZvdW5kYXRpb24udjEuVXBsb2FkUHJlcGFyZWRWMUgAEjYKC2NoYW5nZV9wYWdlGA4gASgLMh8ubWxvLmZvdW5kYXRpb24udjEuQ2hhbmdlUGFnZVYxSAASOQoIZG9jdW1lbnQYDyABKAsyJS5tbG8uZm91bmRhdGlvbi52MS5Eb2N1bWVudFNuYXBzaG90VjFIABJCChFkb3dubG9hZF9wcmVwYXJlZBgQIAEoCzIlLm1sby5mb3VuZGF0aW9uLnYxLkRvd25sb2FkUHJlcGFyZWRWMUgAEjEKCGNvbmZsaWN0GBEgASgLMh0ubWxvLmZvdW5kYXRpb24udjEuQ29uZmxpY3RWMUgAEjEKBWVycm9yGBQgASgLMiAubWxvLmZvdW5kYXRpb24udjEuU3RhYmxlRXJyb3JWMUgAQgkKB291dGNvbWVKBAgCEAMi9gIKEENvbW1pdHRlZEV2ZW50VjESFAoMb3BlcmF0aW9uX2lkGAEgASgMEjQKC2VudGl0eV90eXBlGAIgASgOMh8ubWxvLmZvdW5kYXRpb24udjEuRW50aXR5VHlwZVYxEhEKCWVudGl0eV9pZBgDIAEoDBIyCgpldmVudF90eXBlGAQgASgOMh4ubWxvLmZvdW5kYXRpb24udjEuRXZlbnRUeXBlVjESGgoScmVzdWx0aW5nX3JldmlzaW9uGAUgASgEEhoKEmFjdG9yX2Rpc3BsYXlfbmFtZRgGIAEoCRI1CgZjbGllbnQYCiABKAsyIy5tbG8uZm91bmRhdGlvbi52MS5DbGllbnRTbmFwc2hvdFYxSAASOQoIZG9jdW1lbnQYCyABKAsyJS5tbG8uZm91bmRhdGlvbi52MS5Eb2N1bWVudFNuYXBzaG90VjFIABITCgtzeW5jX2N1cnNvchgMIAEoDEIQCg5yZXByZXNlbnRhdGlvbiKOAQoQU25hcHNob3RFbnRpdHlWMRI1CgZjbGllbnQYASABKAsyIy5tbG8uZm91bmRhdGlvbi52MS5DbGllbnRTbmFwc2hvdFYxSAASOQoIZG9jdW1lbnQYAiABKAsyJS5tbG8uZm91bmRhdGlvbi52MS5Eb2N1bWVudFNuYXBzaG90VjFIAEIICgZlbnRpdHki5wEKDlNuYXBzaG90UGFnZVYxEhMKC3NuYXBzaG90X2lkGAEgASgMEhIKCnBhZ2VfaW5kZXgYAiABKA0SFgoObGFzdF9lbnRpdHlfaWQYBSABKAwSEAoIdGVybWluYWwYByABKAgSOQoQbGFzdF9lbnRpdHlfdHlwZRgIIAEoDjIfLm1sby5mb3VuZGF0aW9uLnYxLkVudGl0eVR5cGVWMRI1CghlbnRpdGllcxgJIAMoCzIjLm1sby5mb3VuZGF0aW9uLnYxLlNuYXBzaG90RW50aXR5VjFKBAgDEARKBAgEEAVKBAgGEAciVgoLRmlsZUNodW5rVjESEwoLdHJhbnNmZXJfaWQYASABKAwSDQoFaW5kZXgYAiABKA0SDQoFYnl0ZXMYAyABKAwSFAoMY2h1bmtfc2hhMjU2GAQgASgMIloKD0Rvd25sb2FkQ2h1bmtWMRITCgt0cmFuc2Zlcl9pZBgBIAEoDBINCgVpbmRleBgCIAEoDRINCgVieXRlcxgDIAEoDBIUCgxjaHVua19zaGEyNTYYBCABKAwiWQoSRG93bmxvYWRDb21wbGV0ZVYxEhMKC3RyYW5zZmVyX2lkGAEgASgMEhQKDHRvdGFsX2NodW5rcxgCIAEoDRIYChBwbGFpbnRleHRfc2hhMjU2GAMgASgMItUBCg5GaWxlVHJhbnNmZXJWMRI2Cgx1cGxvYWRfY2h1bmsYASABKAsyHi5tbG8uZm91bmRhdGlvbi52MS5GaWxlQ2h1bmtWMUgAEjwKDmRvd25sb2FkX2NodW5rGAIgASgLMiIubWxvLmZvdW5kYXRpb24udjEuRG93bmxvYWRDaHVua1YxSAASQgoRZG93bmxvYWRfY29tcGxldGUYAyABKAsyJS5tbG8uZm91bmRhdGlvbi52MS5Eb3dubG9hZENvbXBsZXRlVjFIAEIJCgdtZXNzYWdlIjkKD1NuYXBzaG90QmVnaW5WMRITCgtzbmFwc2hvdF9pZBgBIAEoDBIRCglwYWdlX3NpemUYAiABKA0iQgoSU25hcHNob3RDb21wbGV0ZVYxEhMKC3NuYXBzaG90X2lkGAEgASgMEhcKD3Rlcm1pbmFsX2N1cnNvchgCIAEoDCKOAQoRU25hcHNob3RDb250cm9sVjESMwoFYmVnaW4YASABKAsyIi5tbG8uZm91bmRhdGlvbi52MS5TbmFwc2hvdEJlZ2luVjFIABI5Cghjb21wbGV0ZRgCIAEoCzIlLm1sby5mb3VuZGF0aW9uLnYxLlNuYXBzaG90Q29tcGxldGVWMUgAQgkKB21lc3NhZ2Ui0QEKClByZXNlbmNlVjESEgoKc2Vzc2lvbl9pZBgBIAEoDBIbChNhY3Rvcl9kaXNwbGF5X2xhYmVsGAIgASgJEjQKC2VudGl0eV90eXBlGAMgASgOMh8ubWxvLmZvdW5kYXRpb24udjEuRW50aXR5VHlwZVYxEhEKCWVudGl0eV9pZBgEIAEoDBIxCgVzdGF0ZRgFIAEoDjIiLm1sby5mb3VuZGF0aW9uLnYxLlByZXNlbmNlU3RhdGVWMRIWCg5jbGllbnRfY291bnRlchgGIAEoBCKJAQoQU2Vzc2lvbkNvbnRyb2xWMRI2Cgdjb25maXJtGAEgASgLMiMubWxvLmZvdW5kYXRpb24udjEuU2Vzc2lvbkNvbmZpcm1WMUgAEjIKBXJlYWR5GAIgASgLMiEubWxvLmZvdW5kYXRpb24udjEuU2Vzc2lvblJlYWR5VjFIAEIJCgdtZXNzYWdlIsYECgpFbnZlbG9wZVYxEhIKCm1lc3NhZ2VfaWQYASABKAwSEgoKc2VudF9hdF9tcxgCIAEoBBI+Cg9zZXNzaW9uX2NvbnRyb2wYCiABKAsyIy5tbG8uZm91bmRhdGlvbi52MS5TZXNzaW9uQ29udHJvbFYxSAASNgoHcmVxdWVzdBgLIAEoCzIjLm1sby5mb3VuZGF0aW9uLnYxLkNvbW1hbmRSZXF1ZXN0VjFIABIyCgVxdWVyeRgMIAEoCzIhLm1sby5mb3VuZGF0aW9uLnYxLlF1ZXJ5UmVxdWVzdFYxSAASMQoIcmVzcG9uc2UYDSABKAsyHS5tbG8uZm91bmRhdGlvbi52MS5SZXNwb25zZVYxSAASPgoPY29tbWl0dGVkX2V2ZW50GA4gASgLMiMubWxvLmZvdW5kYXRpb24udjEuQ29tbWl0dGVkRXZlbnRWMUgAEjUKCHNuYXBzaG90GA8gASgLMiEubWxvLmZvdW5kYXRpb24udjEuU25hcHNob3RQYWdlVjFIABI6Cg1maWxlX3RyYW5zZmVyGBAgASgLMiEubWxvLmZvdW5kYXRpb24udjEuRmlsZVRyYW5zZmVyVjFIABIxCghwcmVzZW5jZRgRIAEoCzIdLm1sby5mb3VuZGF0aW9uLnYxLlByZXNlbmNlVjFIABJAChBzbmFwc2hvdF9jb250cm9sGBIgASgLMiQubWxvLmZvdW5kYXRpb24udjEuU25hcHNob3RDb250cm9sVjFIAEIJCgdwYXlsb2FkKnYKC0FjdG9yUm9sZVYxEh0KGUFDVE9SX1JPTEVfVjFfVU5TUEVDSUZJRUQQABIXChNBQ1RPUl9ST0xFX1YxX0FETUlOEAESFQoRQUNUT1JfUk9MRV9WMV9NTE8QAhIYChRBQ1RPUl9ST0xFX1YxX1ZJRVdFUhADKmEKC1N5bmNTdGFydFYxEh0KGVNZTkNfU1RBUlRfVjFfVU5TUEVDSUZJRUQQABIaChZTWU5DX1NUQVJUX1YxX1JFUVVJUkVEEAESFwoTU1lOQ19TVEFSVF9WMV9ERUxUQRACKsgFCgtFcnJvckNvZGVWMRIdChlFUlJPUl9DT0RFX1YxX1VOU1BFQ0lGSUVEEAASIwofRVJST1JfQ09ERV9WMV9WQUxJREFUSU9OX0ZBSUxFRBABEiEKHUVSUk9SX0NPREVfVjFfVU5BVVRIRU5USUNBVEVEEAISHgoaRVJST1JfQ09ERV9WMV9VTkFVVEhPUklaRUQQAxIhCh1FUlJPUl9DT0RFX1YxX1NFU1NJT05fRVhQSVJFRBAEEiEKHUVSUk9SX0NPREVfVjFfU0VTU0lPTl9SRVZPS0VEEAUSIgoeRVJST1JfQ09ERV9WMV9DQVBBQ0lUWV9SRUFDSEVEEAYSJgoiRVJST1JfQ09ERV9WMV9VTlNVUFBPUlRFRF9QUk9UT0NPTBAHEhsKF0VSUk9SX0NPREVfVjFfTk9UX0ZPVU5EEAgSIQodRVJST1JfQ09ERV9WMV9EVVBMSUNBVEVfRU1BSUwQCRIaChZFUlJPUl9DT0RFX1YxX0NPTkZMSUNUEAoSJAogRVJST1JfQ09ERV9WMV9PUEVSQVRJT05fSURfUkVVU0UQCxIgChxFUlJPUl9DT0RFX1YxX0ZJTEVfVE9PX0xBUkdFEAwSJwojRVJST1JfQ09ERV9WMV9VTlNVUFBPUlRFRF9GSUxFX1RZUEUQDRIiCh5FUlJPUl9DT0RFX1YxX0lOVEVHUklUWV9GQUlMRUQQDhIiCh5FUlJPUl9DT0RFX1YxX1RSQU5TRkVSX0VYUElSRUQQDxIkCiBFUlJPUl9DT0RFX1YxX0JBQ0tVUF9VTkFWQUlMQUJMRRAQEiMKH0VSUk9SX0NPREVfVjFfU05BUFNIT1RfUkVRVUlSRUQQERIeChpFUlJPUl9DT0RFX1YxX1JBVEVfTElNSVRFRBASEiAKHEVSUk9SX0NPREVfVjFfSU5URVJOQUxfRVJST1IQEypmCgxFbnRpdHlUeXBlVjESHgoaRU5USVRZX1RZUEVfVjFfVU5TUEVDSUZJRUQQABIZChVFTlRJVFlfVFlQRV9WMV9DTElFTlQQARIbChdFTlRJVFlfVFlQRV9WMV9ET0NVTUVOVBACKsYBCg1Db21tYW5kVHlwZVYxEh8KG0NPTU1BTkRfVFlQRV9WMV9VTlNQRUNJRklFRBAAEiEKHUNPTU1BTkRfVFlQRV9WMV9DUkVBVEVfQ0xJRU5UEAESIQodQ09NTUFORF9UWVBFX1YxX1VQREFURV9DTElFTlQQAhIiCh5DT01NQU5EX1RZUEVfVjFfQVJDSElWRV9DTElFTlQQAxIqCiZDT01NQU5EX1RZUEVfVjFfQ09NTUlUX0RPQ1VNRU5UX1VQTE9BRBAEKqcCCgtRdWVyeVR5cGVWMRIdChlRVUVSWV9UWVBFX1YxX1VOU1BFQ0lGSUVEEAASHgoaUVVFUllfVFlQRV9WMV9MSVNUX0NMSUVOVFMQARIcChhRVUVSWV9UWVBFX1YxX0dFVF9DTElFTlQQAhIgChxRVUVSWV9UWVBFX1YxX0xJU1RfRE9DVU1FTlRTEAMSKQolUVVFUllfVFlQRV9WMV9QUkVQQVJFX0RPQ1VNRU5UX1VQTE9BRBAEEikKJVFVRVJZX1RZUEVfVjFfQkVHSU5fRE9DVU1FTlRfRE9XTkxPQUQQBRIjCh9RVUVSWV9UWVBFX1YxX0dFVF9DSEFOR0VTX0FGVEVSEAYSHgoaUVVFUllfVFlQRV9WMV9HRVRfU05BUFNIT1QQByq5AQoLRXZlbnRUeXBlVjESHQoZRVZFTlRfVFlQRV9WMV9VTlNQRUNJRklFRBAAEiAKHEVWRU5UX1RZUEVfVjFfQ0xJRU5UX0NSRUFURUQQARIgChxFVkVOVF9UWVBFX1YxX0NMSUVOVF9VUERBVEVEEAISIQodRVZFTlRfVFlQRV9WMV9DTElFTlRfQVJDSElWRUQQAxIkCiBFVkVOVF9UWVBFX1YxX0RPQ1VNRU5UX0NPTU1JVFRFRBAEKpABCg9QcmVzZW5jZVN0YXRlVjESIQodUFJFU0VOQ0VfU1RBVEVfVjFfVU5TUEVDSUZJRUQQABIdChlQUkVTRU5DRV9TVEFURV9WMV9WSUVXSU5HEAESHQoZUFJFU0VOQ0VfU1RBVEVfVjFfRURJVElORxACEhwKGFBSRVNFTkNFX1NUQVRFX1YxX1RZUElORxADQicKI2NvbS5tbG9sb2NhbC5wcm90b2NvbC5mb3VuZGF0aW9uLnYxUAFiBnByb3RvMw");

/**
 * @generated from message mlo.foundation.v1.ProtocolVersionV1
 */
export type ProtocolVersionV1 = Message<"mlo.foundation.v1.ProtocolVersionV1"> & {
  /**
   * @generated from field: uint32 major = 1;
   */
  major: number;
};

/**
 * Describes the message mlo.foundation.v1.ProtocolVersionV1.
 * Use `create(ProtocolVersionV1Schema)` to create a new message.
 */
export const ProtocolVersionV1Schema: GenMessage<ProtocolVersionV1> = /*@__PURE__*/
  messageDesc(file_mlo_foundation_v1_foundation, 0);

/**
 * This message is the complete QR/manual-offer payload. It intentionally
 * contains no actor, credential, customer, or private-key material.
 *
 * @generated from message mlo.foundation.v1.PairingOfferV1
 */
export type PairingOfferV1 = Message<"mlo.foundation.v1.PairingOfferV1"> & {
  /**
   * @generated from field: uint32 protocol_major = 1;
   */
  protocolMajor: number;

  /**
   * @generated from field: bytes session_id = 2;
   */
  sessionId: Uint8Array;

  /**
   * @generated from field: string connector_origin = 3;
   */
  connectorOrigin: string;

  /**
   * @generated from field: string signaling_origin = 4;
   */
  signalingOrigin: string;

  /**
   * @generated from field: uint64 expires_at_ms = 5;
   */
  expiresAtMs: bigint;

  /**
   * @generated from field: bytes nonce = 6;
   */
  nonce: Uint8Array;

  /**
   * @generated from field: bytes browser_public_key = 7;
   */
  browserPublicKey: Uint8Array;

  /**
   * @generated from field: string claimed_browser_label = 8;
   */
  claimedBrowserLabel: string;
};

/**
 * Describes the message mlo.foundation.v1.PairingOfferV1.
 * Use `create(PairingOfferV1Schema)` to create a new message.
 */
export const PairingOfferV1Schema: GenMessage<PairingOfferV1> = /*@__PURE__*/
  messageDesc(file_mlo_foundation_v1_foundation, 1);

/**
 * @generated from message mlo.foundation.v1.PhoneKeyResponseV1
 */
export type PhoneKeyResponseV1 = Message<"mlo.foundation.v1.PhoneKeyResponseV1"> & {
  /**
   * @generated from field: bytes session_id = 1;
   */
  sessionId: Uint8Array;

  /**
   * @generated from field: bytes offer_hash = 2;
   */
  offerHash: Uint8Array;

  /**
   * @generated from field: bytes phone_public_key = 3;
   */
  phonePublicKey: Uint8Array;

  /**
   * @generated from field: uint64 expires_at_ms = 4;
   */
  expiresAtMs: bigint;
};

/**
 * Describes the message mlo.foundation.v1.PhoneKeyResponseV1.
 * Use `create(PhoneKeyResponseV1Schema)` to create a new message.
 */
export const PhoneKeyResponseV1Schema: GenMessage<PhoneKeyResponseV1> = /*@__PURE__*/
  messageDesc(file_mlo_foundation_v1_foundation, 2);

/**
 * @generated from message mlo.foundation.v1.PairingApprovedV1
 */
export type PairingApprovedV1 = Message<"mlo.foundation.v1.PairingApprovedV1"> & {
  /**
   * @generated from field: bytes session_id = 1;
   */
  sessionId: Uint8Array;

  /**
   * @generated from field: bytes phone_public_key_fingerprint = 2;
   */
  phonePublicKeyFingerprint: Uint8Array;
};

/**
 * Describes the message mlo.foundation.v1.PairingApprovedV1.
 * Use `create(PairingApprovedV1Schema)` to create a new message.
 */
export const PairingApprovedV1Schema: GenMessage<PairingApprovedV1> = /*@__PURE__*/
  messageDesc(file_mlo_foundation_v1_foundation, 3);

/**
 * @generated from message mlo.foundation.v1.SessionConfirmV1
 */
export type SessionConfirmV1 = Message<"mlo.foundation.v1.SessionConfirmV1"> & {
  /**
   * @generated from field: bytes browser_public_key_fingerprint = 1;
   */
  browserPublicKeyFingerprint: Uint8Array;

  /**
   * @generated from field: bytes phone_public_key_fingerprint = 2;
   */
  phonePublicKeyFingerprint: Uint8Array;

  /**
   * @generated from field: bytes offer_hash = 3;
   */
  offerHash: Uint8Array;

  /**
   * @generated from field: uint32 protocol_major = 4;
   */
  protocolMajor: number;
};

/**
 * Describes the message mlo.foundation.v1.SessionConfirmV1.
 * Use `create(SessionConfirmV1Schema)` to create a new message.
 */
export const SessionConfirmV1Schema: GenMessage<SessionConfirmV1> = /*@__PURE__*/
  messageDesc(file_mlo_foundation_v1_foundation, 4);

/**
 * @generated from message mlo.foundation.v1.SessionReadyV1
 */
export type SessionReadyV1 = Message<"mlo.foundation.v1.SessionReadyV1"> & {
  /**
   * @generated from field: bytes session_id = 1;
   */
  sessionId: Uint8Array;

  /**
   * @generated from field: bytes actor_profile_id = 2;
   */
  actorProfileId: Uint8Array;

  /**
   * @generated from field: string actor_display_name = 3;
   */
  actorDisplayName: string;

  /**
   * @generated from field: mlo.foundation.v1.ActorRoleV1 actor_role = 4;
   */
  actorRole: ActorRoleV1;

  /**
   * @generated from field: uint64 idle_expires_at_ms = 5;
   */
  idleExpiresAtMs: bigint;

  /**
   * @generated from field: uint64 absolute_expires_at_ms = 6;
   */
  absoluteExpiresAtMs: bigint;

  /**
   * @generated from field: uint64 scope_version = 7;
   */
  scopeVersion: bigint;

  /**
   * @generated from field: mlo.foundation.v1.SyncStartV1 sync_start = 8;
   */
  syncStart: SyncStartV1;
};

/**
 * Describes the message mlo.foundation.v1.SessionReadyV1.
 * Use `create(SessionReadyV1Schema)` to create a new message.
 */
export const SessionReadyV1Schema: GenMessage<SessionReadyV1> = /*@__PURE__*/
  messageDesc(file_mlo_foundation_v1_foundation, 5);

/**
 * @generated from message mlo.foundation.v1.StableErrorV1
 */
export type StableErrorV1 = Message<"mlo.foundation.v1.StableErrorV1"> & {
  /**
   * @generated from field: mlo.foundation.v1.ErrorCodeV1 code = 1;
   */
  code: ErrorCodeV1;

  /**
   * @generated from field: string safe_message = 2;
   */
  safeMessage: string;

  /**
   * @generated from field: string correlation_id = 3;
   */
  correlationId: string;
};

/**
 * Describes the message mlo.foundation.v1.StableErrorV1.
 * Use `create(StableErrorV1Schema)` to create a new message.
 */
export const StableErrorV1Schema: GenMessage<StableErrorV1> = /*@__PURE__*/
  messageDesc(file_mlo_foundation_v1_foundation, 6);

/**
 * A stale revision returns the current authorized representation so the client
 * can require an explicit review/reapply. It is intentionally a typed outcome,
 * not a free-form error payload.
 *
 * @generated from message mlo.foundation.v1.ConflictV1
 */
export type ConflictV1 = Message<"mlo.foundation.v1.ConflictV1"> & {
  /**
   * @generated from field: bytes entity_id = 1;
   */
  entityId: Uint8Array;

  /**
   * @generated from field: uint64 current_revision = 2;
   */
  currentRevision: bigint;

  /**
   * @generated from field: bytes rejected_operation_id = 3;
   */
  rejectedOperationId: Uint8Array;

  /**
   * @generated from oneof mlo.foundation.v1.ConflictV1.representation
   */
  representation: {
    /**
     * @generated from field: mlo.foundation.v1.ClientSnapshotV1 client = 10;
     */
    value: ClientSnapshotV1;
    case: "client";
  } | {
    /**
     * @generated from field: mlo.foundation.v1.DocumentSnapshotV1 document = 11;
     */
    value: DocumentSnapshotV1;
    case: "document";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message mlo.foundation.v1.ConflictV1.
 * Use `create(ConflictV1Schema)` to create a new message.
 */
export const ConflictV1Schema: GenMessage<ConflictV1> = /*@__PURE__*/
  messageDesc(file_mlo_foundation_v1_foundation, 7);

/**
 * @generated from message mlo.foundation.v1.IdempotencyMaterialV1
 */
export type IdempotencyMaterialV1 = Message<"mlo.foundation.v1.IdempotencyMaterialV1"> & {
  /**
   * @generated from field: uint32 protocol_major = 1;
   */
  protocolMajor: number;

  /**
   * @generated from field: bytes operation_id = 2;
   */
  operationId: Uint8Array;

  /**
   * @generated from field: bytes session_id = 3;
   */
  sessionId: Uint8Array;

  /**
   * @generated from field: bytes actor_profile_id = 4;
   */
  actorProfileId: Uint8Array;

  /**
   * @generated from field: mlo.foundation.v1.CommandTypeV1 command_type = 5;
   */
  commandType: CommandTypeV1;

  /**
   * @generated from field: mlo.foundation.v1.EntityTypeV1 entity_type = 6;
   */
  entityType: EntityTypeV1;

  /**
   * @generated from field: bytes entity_id = 7;
   */
  entityId: Uint8Array;

  /**
   * @generated from field: uint64 base_revision = 8;
   */
  baseRevision: bigint;

  /**
   * @generated from field: bytes typed_command = 9;
   */
  typedCommand: Uint8Array;
};

/**
 * Describes the message mlo.foundation.v1.IdempotencyMaterialV1.
 * Use `create(IdempotencyMaterialV1Schema)` to create a new message.
 */
export const IdempotencyMaterialV1Schema: GenMessage<IdempotencyMaterialV1> = /*@__PURE__*/
  messageDesc(file_mlo_foundation_v1_foundation, 8);

/**
 * @generated from message mlo.foundation.v1.ClientSnapshotV1
 */
export type ClientSnapshotV1 = Message<"mlo.foundation.v1.ClientSnapshotV1"> & {
  /**
   * @generated from field: bytes client_id = 1;
   */
  clientId: Uint8Array;

  /**
   * @generated from field: bytes owner_actor_id = 2;
   */
  ownerActorId: Uint8Array;

  /**
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * @generated from field: string email = 4;
   */
  email: string;

  /**
   * @generated from field: string phone = 5;
   */
  phone: string;

  /**
   * @generated from field: string address = 6;
   */
  address: string;

  /**
   * @generated from field: string city = 7;
   */
  city: string;

  /**
   * @generated from field: string state = 8;
   */
  state: string;

  /**
   * @generated from field: string postal_code = 9;
   */
  postalCode: string;

  /**
   * @generated from field: repeated string tags = 10;
   */
  tags: string[];

  /**
   * @generated from field: string status = 11;
   */
  status: string;

  /**
   * @generated from field: uint64 revision = 12;
   */
  revision: bigint;

  /**
   * @generated from field: uint64 updated_at_ms = 13;
   */
  updatedAtMs: bigint;

  /**
   * @generated from field: bool archived = 14;
   */
  archived: boolean;

  /**
   * @generated from field: map<string, string> custom_fields = 15;
   */
  customFields: { [key: string]: string };
};

/**
 * Describes the message mlo.foundation.v1.ClientSnapshotV1.
 * Use `create(ClientSnapshotV1Schema)` to create a new message.
 */
export const ClientSnapshotV1Schema: GenMessage<ClientSnapshotV1> = /*@__PURE__*/
  messageDesc(file_mlo_foundation_v1_foundation, 9);

/**
 * @generated from message mlo.foundation.v1.DocumentSnapshotV1
 */
export type DocumentSnapshotV1 = Message<"mlo.foundation.v1.DocumentSnapshotV1"> & {
  /**
   * @generated from field: bytes document_id = 1;
   */
  documentId: Uint8Array;

  /**
   * @generated from field: bytes client_id = 2;
   */
  clientId: Uint8Array;

  /**
   * @generated from field: string display_name = 3;
   */
  displayName: string;

  /**
   * @generated from field: string category = 4;
   */
  category: string;

  /**
   * @generated from field: string status = 5;
   */
  status: string;

  /**
   * @generated from field: uint64 revision = 6;
   */
  revision: bigint;

  /**
   * @generated from field: bytes active_file_version_id = 7;
   */
  activeFileVersionId: Uint8Array;

  /**
   * @generated from field: string notes = 8;
   */
  notes: string;

  /**
   * @generated from field: uint64 updated_at_ms = 9;
   */
  updatedAtMs: bigint;

  /**
   * @generated from field: bool archived = 10;
   */
  archived: boolean;
};

/**
 * Describes the message mlo.foundation.v1.DocumentSnapshotV1.
 * Use `create(DocumentSnapshotV1Schema)` to create a new message.
 */
export const DocumentSnapshotV1Schema: GenMessage<DocumentSnapshotV1> = /*@__PURE__*/
  messageDesc(file_mlo_foundation_v1_foundation, 10);

/**
 * @generated from message mlo.foundation.v1.CreateClientV1
 */
export type CreateClientV1 = Message<"mlo.foundation.v1.CreateClientV1"> & {
  /**
   * @generated from field: bytes owner_actor_id = 1;
   */
  ownerActorId: Uint8Array;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string email = 3;
   */
  email: string;

  /**
   * @generated from field: string phone = 4;
   */
  phone: string;

  /**
   * @generated from field: string address = 5;
   */
  address: string;

  /**
   * @generated from field: string city = 6;
   */
  city: string;

  /**
   * @generated from field: string state = 7;
   */
  state: string;

  /**
   * @generated from field: string postal_code = 8;
   */
  postalCode: string;

  /**
   * @generated from field: repeated string tags = 9;
   */
  tags: string[];

  /**
   * @generated from field: map<string, string> custom_fields = 10;
   */
  customFields: { [key: string]: string };
};

/**
 * Describes the message mlo.foundation.v1.CreateClientV1.
 * Use `create(CreateClientV1Schema)` to create a new message.
 */
export const CreateClientV1Schema: GenMessage<CreateClientV1> = /*@__PURE__*/
  messageDesc(file_mlo_foundation_v1_foundation, 11);

/**
 * @generated from message mlo.foundation.v1.UpdateClientV1
 */
export type UpdateClientV1 = Message<"mlo.foundation.v1.UpdateClientV1"> & {
  /**
   * Paths use canonical snake_case field names. An included path is applied
   * exactly once; optional scalar absence means leave unchanged, while an
   * included empty optional scalar clears the value. `tags` with an empty
   * repeated value clears all tags.
   *
   * @generated from field: repeated string update_mask = 1;
   */
  updateMask: string[];

  /**
   * @generated from field: optional string name = 2;
   */
  name?: string | undefined;

  /**
   * @generated from field: optional string email = 3;
   */
  email?: string | undefined;

  /**
   * @generated from field: optional string phone = 4;
   */
  phone?: string | undefined;

  /**
   * @generated from field: optional string address = 5;
   */
  address?: string | undefined;

  /**
   * @generated from field: optional string city = 6;
   */
  city?: string | undefined;

  /**
   * @generated from field: optional string state = 7;
   */
  state?: string | undefined;

  /**
   * @generated from field: optional string postal_code = 8;
   */
  postalCode?: string | undefined;

  /**
   * @generated from field: repeated string tags = 9;
   */
  tags: string[];

  /**
   * @generated from field: optional string status = 10;
   */
  status?: string | undefined;

  /**
   * @generated from field: map<string, string> custom_fields = 11;
   */
  customFields: { [key: string]: string };
};

/**
 * Describes the message mlo.foundation.v1.UpdateClientV1.
 * Use `create(UpdateClientV1Schema)` to create a new message.
 */
export const UpdateClientV1Schema: GenMessage<UpdateClientV1> = /*@__PURE__*/
  messageDesc(file_mlo_foundation_v1_foundation, 12);

/**
 * @generated from message mlo.foundation.v1.ArchiveClientV1
 */
export type ArchiveClientV1 = Message<"mlo.foundation.v1.ArchiveClientV1"> & {
};

/**
 * Describes the message mlo.foundation.v1.ArchiveClientV1.
 * Use `create(ArchiveClientV1Schema)` to create a new message.
 */
export const ArchiveClientV1Schema: GenMessage<ArchiveClientV1> = /*@__PURE__*/
  messageDesc(file_mlo_foundation_v1_foundation, 13);

/**
 * @generated from message mlo.foundation.v1.CommitDocumentUploadV1
 */
export type CommitDocumentUploadV1 = Message<"mlo.foundation.v1.CommitDocumentUploadV1"> & {
  /**
   * @generated from field: bytes transfer_id = 1;
   */
  transferId: Uint8Array;

  /**
   * @generated from field: bytes document_id = 2;
   */
  documentId: Uint8Array;

  /**
   * @generated from field: bytes file_version_id = 3;
   */
  fileVersionId: Uint8Array;

  /**
   * @generated from field: uint32 total_chunks = 4;
   */
  totalChunks: number;

  /**
   * @generated from field: bytes plaintext_sha256 = 5;
   */
  plaintextSha256: Uint8Array;
};

/**
 * Describes the message mlo.foundation.v1.CommitDocumentUploadV1.
 * Use `create(CommitDocumentUploadV1Schema)` to create a new message.
 */
export const CommitDocumentUploadV1Schema: GenMessage<CommitDocumentUploadV1> = /*@__PURE__*/
  messageDesc(file_mlo_foundation_v1_foundation, 14);

/**
 * @generated from message mlo.foundation.v1.CommandRequestV1
 */
export type CommandRequestV1 = Message<"mlo.foundation.v1.CommandRequestV1"> & {
  /**
   * @generated from field: bytes operation_id = 1;
   */
  operationId: Uint8Array;

  /**
   * @generated from field: bytes actor_profile_id = 2;
   */
  actorProfileId: Uint8Array;

  /**
   * @generated from field: mlo.foundation.v1.EntityTypeV1 entity_type = 3;
   */
  entityType: EntityTypeV1;

  /**
   * @generated from field: bytes entity_id = 4;
   */
  entityId: Uint8Array;

  /**
   * @generated from field: uint64 base_revision = 5;
   */
  baseRevision: bigint;

  /**
   * @generated from oneof mlo.foundation.v1.CommandRequestV1.command
   */
  command: {
    /**
     * @generated from field: mlo.foundation.v1.CreateClientV1 create_client = 10;
     */
    value: CreateClientV1;
    case: "createClient";
  } | {
    /**
     * @generated from field: mlo.foundation.v1.UpdateClientV1 update_client = 11;
     */
    value: UpdateClientV1;
    case: "updateClient";
  } | {
    /**
     * @generated from field: mlo.foundation.v1.ArchiveClientV1 archive_client = 12;
     */
    value: ArchiveClientV1;
    case: "archiveClient";
  } | {
    /**
     * @generated from field: mlo.foundation.v1.CommitDocumentUploadV1 commit_document_upload = 13;
     */
    value: CommitDocumentUploadV1;
    case: "commitDocumentUpload";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message mlo.foundation.v1.CommandRequestV1.
 * Use `create(CommandRequestV1Schema)` to create a new message.
 */
export const CommandRequestV1Schema: GenMessage<CommandRequestV1> = /*@__PURE__*/
  messageDesc(file_mlo_foundation_v1_foundation, 15);

/**
 * @generated from message mlo.foundation.v1.ListClientsRequestV1
 */
export type ListClientsRequestV1 = Message<"mlo.foundation.v1.ListClientsRequestV1"> & {
  /**
   * @generated from field: string query = 1;
   */
  query: string;

  /**
   * @generated from field: string status = 2;
   */
  status: string;

  /**
   * @generated from field: bool include_archived = 3;
   */
  includeArchived: boolean;

  /**
   * @generated from field: uint32 page_size = 4;
   */
  pageSize: number;

  /**
   * @generated from field: bytes cursor = 5;
   */
  cursor: Uint8Array;
};

/**
 * Describes the message mlo.foundation.v1.ListClientsRequestV1.
 * Use `create(ListClientsRequestV1Schema)` to create a new message.
 */
export const ListClientsRequestV1Schema: GenMessage<ListClientsRequestV1> = /*@__PURE__*/
  messageDesc(file_mlo_foundation_v1_foundation, 16);

/**
 * @generated from message mlo.foundation.v1.GetClientRequestV1
 */
export type GetClientRequestV1 = Message<"mlo.foundation.v1.GetClientRequestV1"> & {
  /**
   * @generated from field: bytes client_id = 1;
   */
  clientId: Uint8Array;
};

/**
 * Describes the message mlo.foundation.v1.GetClientRequestV1.
 * Use `create(GetClientRequestV1Schema)` to create a new message.
 */
export const GetClientRequestV1Schema: GenMessage<GetClientRequestV1> = /*@__PURE__*/
  messageDesc(file_mlo_foundation_v1_foundation, 17);

/**
 * @generated from message mlo.foundation.v1.ListDocumentsRequestV1
 */
export type ListDocumentsRequestV1 = Message<"mlo.foundation.v1.ListDocumentsRequestV1"> & {
  /**
   * @generated from field: bytes client_id = 1;
   */
  clientId: Uint8Array;

  /**
   * @generated from field: uint32 page_size = 2;
   */
  pageSize: number;

  /**
   * @generated from field: bytes cursor = 3;
   */
  cursor: Uint8Array;
};

/**
 * Describes the message mlo.foundation.v1.ListDocumentsRequestV1.
 * Use `create(ListDocumentsRequestV1Schema)` to create a new message.
 */
export const ListDocumentsRequestV1Schema: GenMessage<ListDocumentsRequestV1> = /*@__PURE__*/
  messageDesc(file_mlo_foundation_v1_foundation, 18);

/**
 * @generated from message mlo.foundation.v1.PrepareDocumentUploadV1
 */
export type PrepareDocumentUploadV1 = Message<"mlo.foundation.v1.PrepareDocumentUploadV1"> & {
  /**
   * @generated from oneof mlo.foundation.v1.PrepareDocumentUploadV1.target
   */
  target: {
    /**
     * @generated from field: bytes client_id = 1;
     */
    value: Uint8Array;
    case: "clientId";
  } | {
    /**
     * @generated from field: bytes document_id = 2;
     */
    value: Uint8Array;
    case: "documentId";
  } | { case: undefined; value?: undefined };

  /**
   * @generated from field: bytes operation_id = 3;
   */
  operationId: Uint8Array;

  /**
   * @generated from field: uint64 base_revision = 4;
   */
  baseRevision: bigint;

  /**
   * @generated from field: string display_name = 5;
   */
  displayName: string;

  /**
   * @generated from field: string category = 6;
   */
  category: string;

  /**
   * @generated from field: string notes = 7;
   */
  notes: string;

  /**
   * @generated from field: string original_file_name = 8;
   */
  originalFileName: string;

  /**
   * @generated from field: string declared_mime = 9;
   */
  declaredMime: string;

  /**
   * @generated from field: uint64 declared_size = 10;
   */
  declaredSize: bigint;
};

/**
 * Describes the message mlo.foundation.v1.PrepareDocumentUploadV1.
 * Use `create(PrepareDocumentUploadV1Schema)` to create a new message.
 */
export const PrepareDocumentUploadV1Schema: GenMessage<PrepareDocumentUploadV1> = /*@__PURE__*/
  messageDesc(file_mlo_foundation_v1_foundation, 19);

/**
 * Canonical deterministic hash input for an upload prepare. Session and actor
 * binding are deliberately separate from the browser-facing query message.
 *
 * @generated from message mlo.foundation.v1.PrepareUploadMaterialV1
 */
export type PrepareUploadMaterialV1 = Message<"mlo.foundation.v1.PrepareUploadMaterialV1"> & {
  /**
   * @generated from field: uint32 protocol_major = 1;
   */
  protocolMajor: number;

  /**
   * @generated from field: bytes operation_id = 2;
   */
  operationId: Uint8Array;

  /**
   * @generated from field: bytes session_id = 3;
   */
  sessionId: Uint8Array;

  /**
   * @generated from field: bytes actor_profile_id = 4;
   */
  actorProfileId: Uint8Array;

  /**
   * @generated from oneof mlo.foundation.v1.PrepareUploadMaterialV1.target
   */
  target: {
    /**
     * @generated from field: bytes client_id = 5;
     */
    value: Uint8Array;
    case: "clientId";
  } | {
    /**
     * @generated from field: bytes document_id = 6;
     */
    value: Uint8Array;
    case: "documentId";
  } | { case: undefined; value?: undefined };

  /**
   * @generated from field: uint64 base_revision = 7;
   */
  baseRevision: bigint;

  /**
   * @generated from field: string display_name = 8;
   */
  displayName: string;

  /**
   * @generated from field: string category = 9;
   */
  category: string;

  /**
   * @generated from field: string notes = 10;
   */
  notes: string;

  /**
   * @generated from field: string original_file_name = 11;
   */
  originalFileName: string;

  /**
   * @generated from field: string declared_mime = 12;
   */
  declaredMime: string;

  /**
   * @generated from field: uint64 declared_size = 13;
   */
  declaredSize: bigint;
};

/**
 * Describes the message mlo.foundation.v1.PrepareUploadMaterialV1.
 * Use `create(PrepareUploadMaterialV1Schema)` to create a new message.
 */
export const PrepareUploadMaterialV1Schema: GenMessage<PrepareUploadMaterialV1> = /*@__PURE__*/
  messageDesc(file_mlo_foundation_v1_foundation, 20);

/**
 * @generated from message mlo.foundation.v1.BeginDocumentDownloadV1
 */
export type BeginDocumentDownloadV1 = Message<"mlo.foundation.v1.BeginDocumentDownloadV1"> & {
  /**
   * @generated from field: bytes file_version_id = 1;
   */
  fileVersionId: Uint8Array;
};

/**
 * Describes the message mlo.foundation.v1.BeginDocumentDownloadV1.
 * Use `create(BeginDocumentDownloadV1Schema)` to create a new message.
 */
export const BeginDocumentDownloadV1Schema: GenMessage<BeginDocumentDownloadV1> = /*@__PURE__*/
  messageDesc(file_mlo_foundation_v1_foundation, 21);

/**
 * @generated from message mlo.foundation.v1.GetChangesAfterV1
 */
export type GetChangesAfterV1 = Message<"mlo.foundation.v1.GetChangesAfterV1"> & {
  /**
   * @generated from field: bytes cursor = 1;
   */
  cursor: Uint8Array;

  /**
   * @generated from field: uint32 page_size = 2;
   */
  pageSize: number;
};

/**
 * Describes the message mlo.foundation.v1.GetChangesAfterV1.
 * Use `create(GetChangesAfterV1Schema)` to create a new message.
 */
export const GetChangesAfterV1Schema: GenMessage<GetChangesAfterV1> = /*@__PURE__*/
  messageDesc(file_mlo_foundation_v1_foundation, 22);

/**
 * @generated from message mlo.foundation.v1.GetSnapshotV1
 */
export type GetSnapshotV1 = Message<"mlo.foundation.v1.GetSnapshotV1"> & {
  /**
   * @generated from field: bytes snapshot_id = 1;
   */
  snapshotId: Uint8Array;
};

/**
 * Describes the message mlo.foundation.v1.GetSnapshotV1.
 * Use `create(GetSnapshotV1Schema)` to create a new message.
 */
export const GetSnapshotV1Schema: GenMessage<GetSnapshotV1> = /*@__PURE__*/
  messageDesc(file_mlo_foundation_v1_foundation, 23);

/**
 * @generated from message mlo.foundation.v1.QueryRequestV1
 */
export type QueryRequestV1 = Message<"mlo.foundation.v1.QueryRequestV1"> & {
  /**
   * @generated from oneof mlo.foundation.v1.QueryRequestV1.query
   */
  query: {
    /**
     * @generated from field: mlo.foundation.v1.ListClientsRequestV1 list_clients = 10;
     */
    value: ListClientsRequestV1;
    case: "listClients";
  } | {
    /**
     * @generated from field: mlo.foundation.v1.GetClientRequestV1 get_client = 11;
     */
    value: GetClientRequestV1;
    case: "getClient";
  } | {
    /**
     * @generated from field: mlo.foundation.v1.ListDocumentsRequestV1 list_documents = 12;
     */
    value: ListDocumentsRequestV1;
    case: "listDocuments";
  } | {
    /**
     * @generated from field: mlo.foundation.v1.PrepareDocumentUploadV1 prepare_document_upload = 13;
     */
    value: PrepareDocumentUploadV1;
    case: "prepareDocumentUpload";
  } | {
    /**
     * @generated from field: mlo.foundation.v1.BeginDocumentDownloadV1 begin_document_download = 14;
     */
    value: BeginDocumentDownloadV1;
    case: "beginDocumentDownload";
  } | {
    /**
     * @generated from field: mlo.foundation.v1.GetChangesAfterV1 get_changes_after = 15;
     */
    value: GetChangesAfterV1;
    case: "getChangesAfter";
  } | {
    /**
     * @generated from field: mlo.foundation.v1.GetSnapshotV1 get_snapshot = 16;
     */
    value: GetSnapshotV1;
    case: "getSnapshot";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message mlo.foundation.v1.QueryRequestV1.
 * Use `create(QueryRequestV1Schema)` to create a new message.
 */
export const QueryRequestV1Schema: GenMessage<QueryRequestV1> = /*@__PURE__*/
  messageDesc(file_mlo_foundation_v1_foundation, 24);

/**
 * @generated from message mlo.foundation.v1.ClientPageV1
 */
export type ClientPageV1 = Message<"mlo.foundation.v1.ClientPageV1"> & {
  /**
   * @generated from field: repeated mlo.foundation.v1.ClientSnapshotV1 clients = 1;
   */
  clients: ClientSnapshotV1[];

  /**
   * @generated from field: bytes next_cursor = 2;
   */
  nextCursor: Uint8Array;

  /**
   * @generated from field: bool terminal = 3;
   */
  terminal: boolean;
};

/**
 * Describes the message mlo.foundation.v1.ClientPageV1.
 * Use `create(ClientPageV1Schema)` to create a new message.
 */
export const ClientPageV1Schema: GenMessage<ClientPageV1> = /*@__PURE__*/
  messageDesc(file_mlo_foundation_v1_foundation, 25);

/**
 * @generated from message mlo.foundation.v1.DocumentPageV1
 */
export type DocumentPageV1 = Message<"mlo.foundation.v1.DocumentPageV1"> & {
  /**
   * @generated from field: repeated mlo.foundation.v1.DocumentSnapshotV1 documents = 1;
   */
  documents: DocumentSnapshotV1[];

  /**
   * @generated from field: bytes next_cursor = 2;
   */
  nextCursor: Uint8Array;

  /**
   * @generated from field: bool terminal = 3;
   */
  terminal: boolean;
};

/**
 * Describes the message mlo.foundation.v1.DocumentPageV1.
 * Use `create(DocumentPageV1Schema)` to create a new message.
 */
export const DocumentPageV1Schema: GenMessage<DocumentPageV1> = /*@__PURE__*/
  messageDesc(file_mlo_foundation_v1_foundation, 26);

/**
 * @generated from message mlo.foundation.v1.UploadPreparedV1
 */
export type UploadPreparedV1 = Message<"mlo.foundation.v1.UploadPreparedV1"> & {
  /**
   * @generated from field: bytes transfer_id = 1;
   */
  transferId: Uint8Array;

  /**
   * @generated from field: bytes document_id = 2;
   */
  documentId: Uint8Array;

  /**
   * @generated from field: bytes file_version_id = 3;
   */
  fileVersionId: Uint8Array;

  /**
   * @generated from field: uint32 chunk_size = 4;
   */
  chunkSize: number;

  /**
   * @generated from field: uint64 expires_at_ms = 5;
   */
  expiresAtMs: bigint;
};

/**
 * Describes the message mlo.foundation.v1.UploadPreparedV1.
 * Use `create(UploadPreparedV1Schema)` to create a new message.
 */
export const UploadPreparedV1Schema: GenMessage<UploadPreparedV1> = /*@__PURE__*/
  messageDesc(file_mlo_foundation_v1_foundation, 27);

/**
 * @generated from message mlo.foundation.v1.DownloadPreparedV1
 */
export type DownloadPreparedV1 = Message<"mlo.foundation.v1.DownloadPreparedV1"> & {
  /**
   * @generated from field: bytes transfer_id = 1;
   */
  transferId: Uint8Array;

  /**
   * @generated from field: bytes file_version_id = 2;
   */
  fileVersionId: Uint8Array;

  /**
   * @generated from field: uint32 total_chunks = 3;
   */
  totalChunks: number;

  /**
   * @generated from field: uint32 chunk_size = 4;
   */
  chunkSize: number;

  /**
   * @generated from field: uint64 plaintext_size = 5;
   */
  plaintextSize: bigint;

  /**
   * @generated from field: bytes plaintext_sha256 = 6;
   */
  plaintextSha256: Uint8Array;

  /**
   * @generated from field: uint64 expires_at_ms = 7;
   */
  expiresAtMs: bigint;

  /**
   * @generated from field: string original_file_name = 8;
   */
  originalFileName: string;

  /**
   * @generated from field: string mime_type = 9;
   */
  mimeType: string;
};

/**
 * Describes the message mlo.foundation.v1.DownloadPreparedV1.
 * Use `create(DownloadPreparedV1Schema)` to create a new message.
 */
export const DownloadPreparedV1Schema: GenMessage<DownloadPreparedV1> = /*@__PURE__*/
  messageDesc(file_mlo_foundation_v1_foundation, 28);

/**
 * @generated from message mlo.foundation.v1.ChangePageV1
 */
export type ChangePageV1 = Message<"mlo.foundation.v1.ChangePageV1"> & {
  /**
   * @generated from field: repeated mlo.foundation.v1.CommittedEventV1 events = 1;
   */
  events: CommittedEventV1[];

  /**
   * @generated from field: bytes terminal_cursor = 2;
   */
  terminalCursor: Uint8Array;

  /**
   * @generated from field: bool terminal = 3;
   */
  terminal: boolean;

  /**
   * @generated from field: bytes next_cursor = 4;
   */
  nextCursor: Uint8Array;
};

/**
 * Describes the message mlo.foundation.v1.ChangePageV1.
 * Use `create(ChangePageV1Schema)` to create a new message.
 */
export const ChangePageV1Schema: GenMessage<ChangePageV1> = /*@__PURE__*/
  messageDesc(file_mlo_foundation_v1_foundation, 29);

/**
 * @generated from message mlo.foundation.v1.ResponseV1
 */
export type ResponseV1 = Message<"mlo.foundation.v1.ResponseV1"> & {
  /**
   * The protocol validator requires exactly one outcome. A missing outcome is
   * malformed and must be rejected before domain dispatch.
   *
   * @generated from field: bytes request_id = 1;
   */
  requestId: Uint8Array;

  /**
   * @generated from field: bytes sync_cursor = 3;
   */
  syncCursor: Uint8Array;

  /**
   * @generated from oneof mlo.foundation.v1.ResponseV1.outcome
   */
  outcome: {
    /**
     * @generated from field: mlo.foundation.v1.ClientSnapshotV1 client = 10;
     */
    value: ClientSnapshotV1;
    case: "client";
  } | {
    /**
     * @generated from field: mlo.foundation.v1.ClientPageV1 client_page = 11;
     */
    value: ClientPageV1;
    case: "clientPage";
  } | {
    /**
     * @generated from field: mlo.foundation.v1.DocumentPageV1 document_page = 12;
     */
    value: DocumentPageV1;
    case: "documentPage";
  } | {
    /**
     * @generated from field: mlo.foundation.v1.UploadPreparedV1 upload_prepared = 13;
     */
    value: UploadPreparedV1;
    case: "uploadPrepared";
  } | {
    /**
     * @generated from field: mlo.foundation.v1.ChangePageV1 change_page = 14;
     */
    value: ChangePageV1;
    case: "changePage";
  } | {
    /**
     * @generated from field: mlo.foundation.v1.DocumentSnapshotV1 document = 15;
     */
    value: DocumentSnapshotV1;
    case: "document";
  } | {
    /**
     * @generated from field: mlo.foundation.v1.DownloadPreparedV1 download_prepared = 16;
     */
    value: DownloadPreparedV1;
    case: "downloadPrepared";
  } | {
    /**
     * @generated from field: mlo.foundation.v1.ConflictV1 conflict = 17;
     */
    value: ConflictV1;
    case: "conflict";
  } | {
    /**
     * @generated from field: mlo.foundation.v1.StableErrorV1 error = 20;
     */
    value: StableErrorV1;
    case: "error";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message mlo.foundation.v1.ResponseV1.
 * Use `create(ResponseV1Schema)` to create a new message.
 */
export const ResponseV1Schema: GenMessage<ResponseV1> = /*@__PURE__*/
  messageDesc(file_mlo_foundation_v1_foundation, 30);

/**
 * @generated from message mlo.foundation.v1.CommittedEventV1
 */
export type CommittedEventV1 = Message<"mlo.foundation.v1.CommittedEventV1"> & {
  /**
   * @generated from field: bytes operation_id = 1;
   */
  operationId: Uint8Array;

  /**
   * @generated from field: mlo.foundation.v1.EntityTypeV1 entity_type = 2;
   */
  entityType: EntityTypeV1;

  /**
   * @generated from field: bytes entity_id = 3;
   */
  entityId: Uint8Array;

  /**
   * @generated from field: mlo.foundation.v1.EventTypeV1 event_type = 4;
   */
  eventType: EventTypeV1;

  /**
   * @generated from field: uint64 resulting_revision = 5;
   */
  resultingRevision: bigint;

  /**
   * @generated from field: string actor_display_name = 6;
   */
  actorDisplayName: string;

  /**
   * @generated from oneof mlo.foundation.v1.CommittedEventV1.representation
   */
  representation: {
    /**
     * @generated from field: mlo.foundation.v1.ClientSnapshotV1 client = 10;
     */
    value: ClientSnapshotV1;
    case: "client";
  } | {
    /**
     * @generated from field: mlo.foundation.v1.DocumentSnapshotV1 document = 11;
     */
    value: DocumentSnapshotV1;
    case: "document";
  } | { case: undefined; value?: undefined };

  /**
   * @generated from field: bytes sync_cursor = 12;
   */
  syncCursor: Uint8Array;
};

/**
 * Describes the message mlo.foundation.v1.CommittedEventV1.
 * Use `create(CommittedEventV1Schema)` to create a new message.
 */
export const CommittedEventV1Schema: GenMessage<CommittedEventV1> = /*@__PURE__*/
  messageDesc(file_mlo_foundation_v1_foundation, 31);

/**
 * @generated from message mlo.foundation.v1.SnapshotEntityV1
 */
export type SnapshotEntityV1 = Message<"mlo.foundation.v1.SnapshotEntityV1"> & {
  /**
   * @generated from oneof mlo.foundation.v1.SnapshotEntityV1.entity
   */
  entity: {
    /**
     * @generated from field: mlo.foundation.v1.ClientSnapshotV1 client = 1;
     */
    value: ClientSnapshotV1;
    case: "client";
  } | {
    /**
     * @generated from field: mlo.foundation.v1.DocumentSnapshotV1 document = 2;
     */
    value: DocumentSnapshotV1;
    case: "document";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message mlo.foundation.v1.SnapshotEntityV1.
 * Use `create(SnapshotEntityV1Schema)` to create a new message.
 */
export const SnapshotEntityV1Schema: GenMessage<SnapshotEntityV1> = /*@__PURE__*/
  messageDesc(file_mlo_foundation_v1_foundation, 32);

/**
 * @generated from message mlo.foundation.v1.SnapshotPageV1
 */
export type SnapshotPageV1 = Message<"mlo.foundation.v1.SnapshotPageV1"> & {
  /**
   * @generated from field: bytes snapshot_id = 1;
   */
  snapshotId: Uint8Array;

  /**
   * @generated from field: uint32 page_index = 2;
   */
  pageIndex: number;

  /**
   * @generated from field: bytes last_entity_id = 5;
   */
  lastEntityId: Uint8Array;

  /**
   * @generated from field: bool terminal = 7;
   */
  terminal: boolean;

  /**
   * @generated from field: mlo.foundation.v1.EntityTypeV1 last_entity_type = 8;
   */
  lastEntityType: EntityTypeV1;

  /**
   * @generated from field: repeated mlo.foundation.v1.SnapshotEntityV1 entities = 9;
   */
  entities: SnapshotEntityV1[];
};

/**
 * Describes the message mlo.foundation.v1.SnapshotPageV1.
 * Use `create(SnapshotPageV1Schema)` to create a new message.
 */
export const SnapshotPageV1Schema: GenMessage<SnapshotPageV1> = /*@__PURE__*/
  messageDesc(file_mlo_foundation_v1_foundation, 33);

/**
 * @generated from message mlo.foundation.v1.FileChunkV1
 */
export type FileChunkV1 = Message<"mlo.foundation.v1.FileChunkV1"> & {
  /**
   * @generated from field: bytes transfer_id = 1;
   */
  transferId: Uint8Array;

  /**
   * @generated from field: uint32 index = 2;
   */
  index: number;

  /**
   * @generated from field: bytes bytes = 3;
   */
  bytes: Uint8Array;

  /**
   * @generated from field: bytes chunk_sha256 = 4;
   */
  chunkSha256: Uint8Array;
};

/**
 * Describes the message mlo.foundation.v1.FileChunkV1.
 * Use `create(FileChunkV1Schema)` to create a new message.
 */
export const FileChunkV1Schema: GenMessage<FileChunkV1> = /*@__PURE__*/
  messageDesc(file_mlo_foundation_v1_foundation, 34);

/**
 * @generated from message mlo.foundation.v1.DownloadChunkV1
 */
export type DownloadChunkV1 = Message<"mlo.foundation.v1.DownloadChunkV1"> & {
  /**
   * @generated from field: bytes transfer_id = 1;
   */
  transferId: Uint8Array;

  /**
   * @generated from field: uint32 index = 2;
   */
  index: number;

  /**
   * @generated from field: bytes bytes = 3;
   */
  bytes: Uint8Array;

  /**
   * @generated from field: bytes chunk_sha256 = 4;
   */
  chunkSha256: Uint8Array;
};

/**
 * Describes the message mlo.foundation.v1.DownloadChunkV1.
 * Use `create(DownloadChunkV1Schema)` to create a new message.
 */
export const DownloadChunkV1Schema: GenMessage<DownloadChunkV1> = /*@__PURE__*/
  messageDesc(file_mlo_foundation_v1_foundation, 35);

/**
 * @generated from message mlo.foundation.v1.DownloadCompleteV1
 */
export type DownloadCompleteV1 = Message<"mlo.foundation.v1.DownloadCompleteV1"> & {
  /**
   * @generated from field: bytes transfer_id = 1;
   */
  transferId: Uint8Array;

  /**
   * @generated from field: uint32 total_chunks = 2;
   */
  totalChunks: number;

  /**
   * @generated from field: bytes plaintext_sha256 = 3;
   */
  plaintextSha256: Uint8Array;
};

/**
 * Describes the message mlo.foundation.v1.DownloadCompleteV1.
 * Use `create(DownloadCompleteV1Schema)` to create a new message.
 */
export const DownloadCompleteV1Schema: GenMessage<DownloadCompleteV1> = /*@__PURE__*/
  messageDesc(file_mlo_foundation_v1_foundation, 36);

/**
 * @generated from message mlo.foundation.v1.FileTransferV1
 */
export type FileTransferV1 = Message<"mlo.foundation.v1.FileTransferV1"> & {
  /**
   * @generated from oneof mlo.foundation.v1.FileTransferV1.message
   */
  message: {
    /**
     * @generated from field: mlo.foundation.v1.FileChunkV1 upload_chunk = 1;
     */
    value: FileChunkV1;
    case: "uploadChunk";
  } | {
    /**
     * @generated from field: mlo.foundation.v1.DownloadChunkV1 download_chunk = 2;
     */
    value: DownloadChunkV1;
    case: "downloadChunk";
  } | {
    /**
     * @generated from field: mlo.foundation.v1.DownloadCompleteV1 download_complete = 3;
     */
    value: DownloadCompleteV1;
    case: "downloadComplete";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message mlo.foundation.v1.FileTransferV1.
 * Use `create(FileTransferV1Schema)` to create a new message.
 */
export const FileTransferV1Schema: GenMessage<FileTransferV1> = /*@__PURE__*/
  messageDesc(file_mlo_foundation_v1_foundation, 37);

/**
 * @generated from message mlo.foundation.v1.SnapshotBeginV1
 */
export type SnapshotBeginV1 = Message<"mlo.foundation.v1.SnapshotBeginV1"> & {
  /**
   * @generated from field: bytes snapshot_id = 1;
   */
  snapshotId: Uint8Array;

  /**
   * @generated from field: uint32 page_size = 2;
   */
  pageSize: number;
};

/**
 * Describes the message mlo.foundation.v1.SnapshotBeginV1.
 * Use `create(SnapshotBeginV1Schema)` to create a new message.
 */
export const SnapshotBeginV1Schema: GenMessage<SnapshotBeginV1> = /*@__PURE__*/
  messageDesc(file_mlo_foundation_v1_foundation, 38);

/**
 * @generated from message mlo.foundation.v1.SnapshotCompleteV1
 */
export type SnapshotCompleteV1 = Message<"mlo.foundation.v1.SnapshotCompleteV1"> & {
  /**
   * @generated from field: bytes snapshot_id = 1;
   */
  snapshotId: Uint8Array;

  /**
   * @generated from field: bytes terminal_cursor = 2;
   */
  terminalCursor: Uint8Array;
};

/**
 * Describes the message mlo.foundation.v1.SnapshotCompleteV1.
 * Use `create(SnapshotCompleteV1Schema)` to create a new message.
 */
export const SnapshotCompleteV1Schema: GenMessage<SnapshotCompleteV1> = /*@__PURE__*/
  messageDesc(file_mlo_foundation_v1_foundation, 39);

/**
 * @generated from message mlo.foundation.v1.SnapshotControlV1
 */
export type SnapshotControlV1 = Message<"mlo.foundation.v1.SnapshotControlV1"> & {
  /**
   * @generated from oneof mlo.foundation.v1.SnapshotControlV1.message
   */
  message: {
    /**
     * @generated from field: mlo.foundation.v1.SnapshotBeginV1 begin = 1;
     */
    value: SnapshotBeginV1;
    case: "begin";
  } | {
    /**
     * @generated from field: mlo.foundation.v1.SnapshotCompleteV1 complete = 2;
     */
    value: SnapshotCompleteV1;
    case: "complete";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message mlo.foundation.v1.SnapshotControlV1.
 * Use `create(SnapshotControlV1Schema)` to create a new message.
 */
export const SnapshotControlV1Schema: GenMessage<SnapshotControlV1> = /*@__PURE__*/
  messageDesc(file_mlo_foundation_v1_foundation, 40);

/**
 * @generated from message mlo.foundation.v1.PresenceV1
 */
export type PresenceV1 = Message<"mlo.foundation.v1.PresenceV1"> & {
  /**
   * @generated from field: bytes session_id = 1;
   */
  sessionId: Uint8Array;

  /**
   * @generated from field: string actor_display_label = 2;
   */
  actorDisplayLabel: string;

  /**
   * @generated from field: mlo.foundation.v1.EntityTypeV1 entity_type = 3;
   */
  entityType: EntityTypeV1;

  /**
   * @generated from field: bytes entity_id = 4;
   */
  entityId: Uint8Array;

  /**
   * @generated from field: mlo.foundation.v1.PresenceStateV1 state = 5;
   */
  state: PresenceStateV1;

  /**
   * @generated from field: uint64 client_counter = 6;
   */
  clientCounter: bigint;
};

/**
 * Describes the message mlo.foundation.v1.PresenceV1.
 * Use `create(PresenceV1Schema)` to create a new message.
 */
export const PresenceV1Schema: GenMessage<PresenceV1> = /*@__PURE__*/
  messageDesc(file_mlo_foundation_v1_foundation, 41);

/**
 * @generated from message mlo.foundation.v1.SessionControlV1
 */
export type SessionControlV1 = Message<"mlo.foundation.v1.SessionControlV1"> & {
  /**
   * @generated from oneof mlo.foundation.v1.SessionControlV1.message
   */
  message: {
    /**
     * @generated from field: mlo.foundation.v1.SessionConfirmV1 confirm = 1;
     */
    value: SessionConfirmV1;
    case: "confirm";
  } | {
    /**
     * @generated from field: mlo.foundation.v1.SessionReadyV1 ready = 2;
     */
    value: SessionReadyV1;
    case: "ready";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message mlo.foundation.v1.SessionControlV1.
 * Use `create(SessionControlV1Schema)` to create a new message.
 */
export const SessionControlV1Schema: GenMessage<SessionControlV1> = /*@__PURE__*/
  messageDesc(file_mlo_foundation_v1_foundation, 42);

/**
 * @generated from message mlo.foundation.v1.EnvelopeV1
 */
export type EnvelopeV1 = Message<"mlo.foundation.v1.EnvelopeV1"> & {
  /**
   * @generated from field: bytes message_id = 1;
   */
  messageId: Uint8Array;

  /**
   * @generated from field: uint64 sent_at_ms = 2;
   */
  sentAtMs: bigint;

  /**
   * @generated from oneof mlo.foundation.v1.EnvelopeV1.payload
   */
  payload: {
    /**
     * @generated from field: mlo.foundation.v1.SessionControlV1 session_control = 10;
     */
    value: SessionControlV1;
    case: "sessionControl";
  } | {
    /**
     * @generated from field: mlo.foundation.v1.CommandRequestV1 request = 11;
     */
    value: CommandRequestV1;
    case: "request";
  } | {
    /**
     * @generated from field: mlo.foundation.v1.QueryRequestV1 query = 12;
     */
    value: QueryRequestV1;
    case: "query";
  } | {
    /**
     * @generated from field: mlo.foundation.v1.ResponseV1 response = 13;
     */
    value: ResponseV1;
    case: "response";
  } | {
    /**
     * @generated from field: mlo.foundation.v1.CommittedEventV1 committed_event = 14;
     */
    value: CommittedEventV1;
    case: "committedEvent";
  } | {
    /**
     * @generated from field: mlo.foundation.v1.SnapshotPageV1 snapshot = 15;
     */
    value: SnapshotPageV1;
    case: "snapshot";
  } | {
    /**
     * @generated from field: mlo.foundation.v1.FileTransferV1 file_transfer = 16;
     */
    value: FileTransferV1;
    case: "fileTransfer";
  } | {
    /**
     * @generated from field: mlo.foundation.v1.PresenceV1 presence = 17;
     */
    value: PresenceV1;
    case: "presence";
  } | {
    /**
     * @generated from field: mlo.foundation.v1.SnapshotControlV1 snapshot_control = 18;
     */
    value: SnapshotControlV1;
    case: "snapshotControl";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message mlo.foundation.v1.EnvelopeV1.
 * Use `create(EnvelopeV1Schema)` to create a new message.
 */
export const EnvelopeV1Schema: GenMessage<EnvelopeV1> = /*@__PURE__*/
  messageDesc(file_mlo_foundation_v1_foundation, 43);

/**
 * @generated from enum mlo.foundation.v1.ActorRoleV1
 */
export enum ActorRoleV1 {
  /**
   * @generated from enum value: ACTOR_ROLE_V1_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: ACTOR_ROLE_V1_ADMIN = 1;
   */
  ADMIN = 1,

  /**
   * @generated from enum value: ACTOR_ROLE_V1_MLO = 2;
   */
  MLO = 2,

  /**
   * @generated from enum value: ACTOR_ROLE_V1_VIEWER = 3;
   */
  VIEWER = 3,
}

/**
 * Describes the enum mlo.foundation.v1.ActorRoleV1.
 */
export const ActorRoleV1Schema: GenEnum<ActorRoleV1> = /*@__PURE__*/
  enumDesc(file_mlo_foundation_v1_foundation, 0);

/**
 * @generated from enum mlo.foundation.v1.SyncStartV1
 */
export enum SyncStartV1 {
  /**
   * @generated from enum value: SYNC_START_V1_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: SYNC_START_V1_REQUIRED = 1;
   */
  REQUIRED = 1,

  /**
   * @generated from enum value: SYNC_START_V1_DELTA = 2;
   */
  DELTA = 2,
}

/**
 * Describes the enum mlo.foundation.v1.SyncStartV1.
 */
export const SyncStartV1Schema: GenEnum<SyncStartV1> = /*@__PURE__*/
  enumDesc(file_mlo_foundation_v1_foundation, 1);

/**
 * @generated from enum mlo.foundation.v1.ErrorCodeV1
 */
export enum ErrorCodeV1 {
  /**
   * @generated from enum value: ERROR_CODE_V1_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: ERROR_CODE_V1_VALIDATION_FAILED = 1;
   */
  VALIDATION_FAILED = 1,

  /**
   * @generated from enum value: ERROR_CODE_V1_UNAUTHENTICATED = 2;
   */
  UNAUTHENTICATED = 2,

  /**
   * @generated from enum value: ERROR_CODE_V1_UNAUTHORIZED = 3;
   */
  UNAUTHORIZED = 3,

  /**
   * @generated from enum value: ERROR_CODE_V1_SESSION_EXPIRED = 4;
   */
  SESSION_EXPIRED = 4,

  /**
   * @generated from enum value: ERROR_CODE_V1_SESSION_REVOKED = 5;
   */
  SESSION_REVOKED = 5,

  /**
   * @generated from enum value: ERROR_CODE_V1_CAPACITY_REACHED = 6;
   */
  CAPACITY_REACHED = 6,

  /**
   * @generated from enum value: ERROR_CODE_V1_UNSUPPORTED_PROTOCOL = 7;
   */
  UNSUPPORTED_PROTOCOL = 7,

  /**
   * @generated from enum value: ERROR_CODE_V1_NOT_FOUND = 8;
   */
  NOT_FOUND = 8,

  /**
   * @generated from enum value: ERROR_CODE_V1_DUPLICATE_EMAIL = 9;
   */
  DUPLICATE_EMAIL = 9,

  /**
   * @generated from enum value: ERROR_CODE_V1_CONFLICT = 10;
   */
  CONFLICT = 10,

  /**
   * @generated from enum value: ERROR_CODE_V1_OPERATION_ID_REUSE = 11;
   */
  OPERATION_ID_REUSE = 11,

  /**
   * @generated from enum value: ERROR_CODE_V1_FILE_TOO_LARGE = 12;
   */
  FILE_TOO_LARGE = 12,

  /**
   * @generated from enum value: ERROR_CODE_V1_UNSUPPORTED_FILE_TYPE = 13;
   */
  UNSUPPORTED_FILE_TYPE = 13,

  /**
   * @generated from enum value: ERROR_CODE_V1_INTEGRITY_FAILED = 14;
   */
  INTEGRITY_FAILED = 14,

  /**
   * @generated from enum value: ERROR_CODE_V1_TRANSFER_EXPIRED = 15;
   */
  TRANSFER_EXPIRED = 15,

  /**
   * @generated from enum value: ERROR_CODE_V1_BACKUP_UNAVAILABLE = 16;
   */
  BACKUP_UNAVAILABLE = 16,

  /**
   * @generated from enum value: ERROR_CODE_V1_SNAPSHOT_REQUIRED = 17;
   */
  SNAPSHOT_REQUIRED = 17,

  /**
   * @generated from enum value: ERROR_CODE_V1_RATE_LIMITED = 18;
   */
  RATE_LIMITED = 18,

  /**
   * @generated from enum value: ERROR_CODE_V1_INTERNAL_ERROR = 19;
   */
  INTERNAL_ERROR = 19,
}

/**
 * Describes the enum mlo.foundation.v1.ErrorCodeV1.
 */
export const ErrorCodeV1Schema: GenEnum<ErrorCodeV1> = /*@__PURE__*/
  enumDesc(file_mlo_foundation_v1_foundation, 2);

/**
 * @generated from enum mlo.foundation.v1.EntityTypeV1
 */
export enum EntityTypeV1 {
  /**
   * @generated from enum value: ENTITY_TYPE_V1_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: ENTITY_TYPE_V1_CLIENT = 1;
   */
  CLIENT = 1,

  /**
   * @generated from enum value: ENTITY_TYPE_V1_DOCUMENT = 2;
   */
  DOCUMENT = 2,
}

/**
 * Describes the enum mlo.foundation.v1.EntityTypeV1.
 */
export const EntityTypeV1Schema: GenEnum<EntityTypeV1> = /*@__PURE__*/
  enumDesc(file_mlo_foundation_v1_foundation, 3);

/**
 * @generated from enum mlo.foundation.v1.CommandTypeV1
 */
export enum CommandTypeV1 {
  /**
   * @generated from enum value: COMMAND_TYPE_V1_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: COMMAND_TYPE_V1_CREATE_CLIENT = 1;
   */
  CREATE_CLIENT = 1,

  /**
   * @generated from enum value: COMMAND_TYPE_V1_UPDATE_CLIENT = 2;
   */
  UPDATE_CLIENT = 2,

  /**
   * @generated from enum value: COMMAND_TYPE_V1_ARCHIVE_CLIENT = 3;
   */
  ARCHIVE_CLIENT = 3,

  /**
   * @generated from enum value: COMMAND_TYPE_V1_COMMIT_DOCUMENT_UPLOAD = 4;
   */
  COMMIT_DOCUMENT_UPLOAD = 4,
}

/**
 * Describes the enum mlo.foundation.v1.CommandTypeV1.
 */
export const CommandTypeV1Schema: GenEnum<CommandTypeV1> = /*@__PURE__*/
  enumDesc(file_mlo_foundation_v1_foundation, 4);

/**
 * @generated from enum mlo.foundation.v1.QueryTypeV1
 */
export enum QueryTypeV1 {
  /**
   * @generated from enum value: QUERY_TYPE_V1_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: QUERY_TYPE_V1_LIST_CLIENTS = 1;
   */
  LIST_CLIENTS = 1,

  /**
   * @generated from enum value: QUERY_TYPE_V1_GET_CLIENT = 2;
   */
  GET_CLIENT = 2,

  /**
   * @generated from enum value: QUERY_TYPE_V1_LIST_DOCUMENTS = 3;
   */
  LIST_DOCUMENTS = 3,

  /**
   * @generated from enum value: QUERY_TYPE_V1_PREPARE_DOCUMENT_UPLOAD = 4;
   */
  PREPARE_DOCUMENT_UPLOAD = 4,

  /**
   * @generated from enum value: QUERY_TYPE_V1_BEGIN_DOCUMENT_DOWNLOAD = 5;
   */
  BEGIN_DOCUMENT_DOWNLOAD = 5,

  /**
   * @generated from enum value: QUERY_TYPE_V1_GET_CHANGES_AFTER = 6;
   */
  GET_CHANGES_AFTER = 6,

  /**
   * @generated from enum value: QUERY_TYPE_V1_GET_SNAPSHOT = 7;
   */
  GET_SNAPSHOT = 7,
}

/**
 * Describes the enum mlo.foundation.v1.QueryTypeV1.
 */
export const QueryTypeV1Schema: GenEnum<QueryTypeV1> = /*@__PURE__*/
  enumDesc(file_mlo_foundation_v1_foundation, 5);

/**
 * @generated from enum mlo.foundation.v1.EventTypeV1
 */
export enum EventTypeV1 {
  /**
   * @generated from enum value: EVENT_TYPE_V1_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: EVENT_TYPE_V1_CLIENT_CREATED = 1;
   */
  CLIENT_CREATED = 1,

  /**
   * @generated from enum value: EVENT_TYPE_V1_CLIENT_UPDATED = 2;
   */
  CLIENT_UPDATED = 2,

  /**
   * @generated from enum value: EVENT_TYPE_V1_CLIENT_ARCHIVED = 3;
   */
  CLIENT_ARCHIVED = 3,

  /**
   * @generated from enum value: EVENT_TYPE_V1_DOCUMENT_COMMITTED = 4;
   */
  DOCUMENT_COMMITTED = 4,
}

/**
 * Describes the enum mlo.foundation.v1.EventTypeV1.
 */
export const EventTypeV1Schema: GenEnum<EventTypeV1> = /*@__PURE__*/
  enumDesc(file_mlo_foundation_v1_foundation, 6);

/**
 * @generated from enum mlo.foundation.v1.PresenceStateV1
 */
export enum PresenceStateV1 {
  /**
   * @generated from enum value: PRESENCE_STATE_V1_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: PRESENCE_STATE_V1_VIEWING = 1;
   */
  VIEWING = 1,

  /**
   * @generated from enum value: PRESENCE_STATE_V1_EDITING = 2;
   */
  EDITING = 2,

  /**
   * @generated from enum value: PRESENCE_STATE_V1_TYPING = 3;
   */
  TYPING = 3,
}

/**
 * Describes the enum mlo.foundation.v1.PresenceStateV1.
 */
export const PresenceStateV1Schema: GenEnum<PresenceStateV1> = /*@__PURE__*/
  enumDesc(file_mlo_foundation_v1_foundation, 7);

